const configs = {
  local: {
    awsConfig: {
      Auth: {
        region: 'ap-northeast-1',
        userPoolId: 'ap-northeast-1_GYi4Wj9l3',
        userPoolWebClientId: '757q0lhss2ikevtn72u8eh7pgq'
      }
    },
    apiBaseUrl: 'https://staging-api-izone.withlive.co.uk'
  },
  development: {
    awsConfig: {
      Auth: {
        region: 'ap-northeast-1',
        userPoolId: 'ap-northeast-1_GYi4Wj9l3',
        userPoolWebClientId: '757q0lhss2ikevtn72u8eh7pgq'
      }
    },
    apiBaseUrl: 'https://staging-api-izone.withlive.co.uk'
  },
  staging: {
    awsConfig: {
      Auth: {
        region: 'ap-northeast-1',
        userPoolId: 'ap-northeast-1_GYi4Wj9l3',
        userPoolWebClientId: '757q0lhss2ikevtn72u8eh7pgq'
      }
    },
    apiBaseUrl: 'https://staging-api-izone.withlive.co.uk'
  },
  production: {
    awsConfig: {
      Auth: {
        region: 'ap-northeast-1',
        userPoolId: 'ap-northeast-1_J4GSPgxxK',
        userPoolWebClientId: '5olbqiht265fa31bp8mibs1tib'
      }
    },
    apiBaseUrl: 'https://production-api-izone.withlive.co.uk'
  }
}

const commons = {
  appleStoreUrl: 'https://apps.apple.com/jp/app/id1458767058',
  googlePlayStoreUrl:
    'https://play.google.com/store/apps/details?id=jp.withlive.girls&hl=ja',
  instructionsUrl:
    'https://withlive-data.s3-ap-northeast-1.amazonaws.com/izone/Instructions.pdf'
}

export default {
  ...configs[process.env.STAGE],
  stage: process.env.STAGE,
  ...commons
}
